import React, { useState } from 'react';
import { FaWhatsapp, FaCog, FaCheck, FaCopy } from 'react-icons/fa';
import LoadingButton from '../../components/common/LoadingButton';
import PrimaryButton from '../../components/common/PrimaryButton';
import ReusableTextField from '../../components/common/ReusableTextField';
import { FaInfoCircle, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import '../../assets/css/WhatsAppSetup.css';
import SegmentedBar from '../../components/common/SegmentedBar';

import { 
    WhatsAppConnectionStatus, 
    WhatsAppOAuthStatus, 
    WhatsAppTexts, 
    WhatsAppTabIds, 
    WhatsAppLoadingStates, 
    WhatsAppSetupSteps, 
    ServerConnectionStatus } from '../../constants/whatsAppConstants';



  // Copy to clipboard function
const copyToClipboard = async (text) => {
    try {
        await navigator.clipboard.writeText(text);
        console.log('Copied to clipboard:', text);
        // You can add a toast notification here
    } catch (error) {
        console.error('Failed to copy:', error);
    }
};

const WhatsAppOAuth = (
    { onOAuthClicked, onGenerateWebhookClicked, whatsAppOAuthConnected, webhookGenerationCompleted, webhookCredentialsValues, loadingStatesValues, onConfirmWebhookUpdatedClicked }
) => {
    const whatsAppOauthConnected = whatsAppOAuthConnected
    const webhookGenerated = webhookGenerationCompleted || false;
    const webhookCredentials = webhookCredentialsValues || null;
    const loadingStates = loadingStatesValues

    return (
        <div className="whatsapp-setup-wrapper">
        <div>
              <h3 className="section-title">{WhatsAppTexts.LEADS_SETUP_TITLE}</h3>
              <p className="section-subtitle">
                {WhatsAppTexts.LEADS_SETUP_SUBTITLE}
              </p>
    
              {/* Setup Cards */}
                <div className="setup-cards-container">
                  {/* Connect WhatsApp Card */}
                  <div className={`setup-card`}>
                  <div className="setup-card-header">
                    <div key={whatsAppOauthConnected}
                    className={`setup-card-icon whatsapp`}>
                      <FaWhatsapp />
                      {whatsAppOauthConnected && (
                        <div className="checkmark-overlay">
                          <FaCheck className="checkmark-icon" />
                        </div>
                      )}
                    </div>
                    <h4 className="setup-card-title">{WhatsAppTexts.CONNECT_WHATSAPP_TITLE}</h4>
                  </div>
                    <p className="setup-card-description">
                      {WhatsAppTexts.CONNECT_WHATSAPP_DESCRIPTION}
                    </p>
                    <LoadingButton
                      className="setup-card-button"
                      loading={loadingStates.connecting}
                      loadingText={WhatsAppTexts.CONNECTING}
                      onClick={onOAuthClicked}
                      disabled={whatsAppOauthConnected}
                    >
                      {WhatsAppTexts.CONNECT_BUTTON_TEXT}
                    </LoadingButton>
                  </div>
    
                  {/* Generate Webhook Card */}
                  <div className="setup-card">
                    <div className="setup-card-header">
                      <div className="setup-card-icon webhook">
                        <FaCog />
                      </div>
                      <h4 className="setup-card-title">{WhatsAppTexts.GENERATE_WEBHOOK_TITLE}</h4>
                    </div>
                    <p className="setup-card-description">
                      {WhatsAppTexts.GENERATE_WEBHOOK_DESCRIPTION}
                    </p>
                    <LoadingButton
                      className="setup-card-button"
                      loading={loadingStates.generating}
                      loadingText={WhatsAppTexts.GENERATING}
                      onClick={onGenerateWebhookClicked}
                      disabled={whatsAppOauthConnected == false }
                    >
                      {WhatsAppTexts.GENERATE_WEBHOOK_BUTTON_TEXT}
                    </LoadingButton>
                  </div>
                </div>
    
              {/* Webhook Credentials Display */}
              {webhookGenerated && webhookCredentials && (
                <div className="webhook-credentials">
                  <h4 style={{ marginBottom: '16px', color: '#333' }}>{WhatsAppTexts.WEBHOOK_CONFIG_TITLE}</h4>
                  <p style={{ marginBottom: '20px', color: '#666' }}>
                    {WhatsAppTexts.WEBHOOK_CREDENTIALS_DESCRIPTION}
                  </p>
                  
                  <div className="webhook-field">
                    <label className="webhook-label">{WhatsAppTexts.WEBHOOK_URL_LABEL}</label>
                    <div className="webhook-value">
                      <span className="webhook-url">{webhookCredentials.webhookUrl}</span>
                      <button
                        className="copy-button"
                        onClick={() => copyToClipboard(webhookCredentials.webhookUrl)}
                      >
                        <FaCopy />
                      </button>
                    </div>
                  </div>
                  
                  <div className="webhook-field">
                    <label className="webhook-label">{WhatsAppTexts.VERIFY_TOKEN_LABEL}</label>
                    <div className="webhook-value">
                      <span className="webhook-url">{webhookCredentials.verifyToken}</span>
                      <button
                        className="copy-button"
                        onClick={() => copyToClipboard(webhookCredentials.verifyToken)}
                      >
                        <FaCopy />
                      </button>
                    </div>
                  </div>
    
                  <div className="webhook-setup-instructions">
                    <div className="setup-instructions-header">
                      <FaCog className="setup-instructions-icon" />
                      <h5 className="setup-instructions-title">{WhatsAppTexts.BUSINESS_MANAGER_TITLE}</h5>
                    </div>
                    <p className="setup-instructions-subtitle">
                      {WhatsAppTexts.BUSINESS_MANAGER_SUBTITLE}
                    </p>
                    <ol className="setup-instructions-list">
                      <li>{WhatsAppSetupSteps.WHATSAPP_BUSINESS_MANAGER_STEP_1}</li>
                      <li>{WhatsAppSetupSteps.WHATSAPP_BUSINESS_MANAGER_STEP_2}</li>
                      <li>{WhatsAppSetupSteps.WHATSAPP_BUSINESS_MANAGER_STEP_3}</li>
                      <li>{WhatsAppSetupSteps.WHATSAPP_BUSINESS_MANAGER_STEP_4}</li>
                      <li>{WhatsAppSetupSteps.WHATSAPP_BUSINESS_MANAGER_STEP_5}</li>
                      <li>{WhatsAppSetupSteps.WHATSAPP_BUSINESS_MANAGER_STEP_6}</li>
                    </ol>
                  </div>

                  <br />
                  <br />
                  <div className="confirm-webhook-updated-button">
                    <h6 className="confirm-webhook-updated-title">{WhatsAppTexts.CONFIRM_WEBHOOK_UPDATED_TITLE}</h6>
                    <br />
                    <br />
                    <PrimaryButton onClick={onConfirmWebhookUpdatedClicked}>
                    {WhatsAppTexts.CONFIRM_WEBHOOK_UPDATED_BUTTON_TEXT}
                    </PrimaryButton>
                </div>
                </div>
              )}
            </div>
        </div>
      );
    };

    export default WhatsAppOAuth;